import api from "Common/Client/Interceptor";

const getAuthHeaders = () => ({
  accept: "*/*",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const fetchInvites = async (selectedRole) => {
  try {
    const response = await api.get(`TenantUserInvites/Admin/GetList?rolesEnum=${selectedRole}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const resendInvite = async (inviteId) => {
  try {
    const response = await api.post(
      `TenantUserInvites/resend-invitation/${inviteId}`,
      null,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    return {
      success: false,
      error: {
        message: error.response?.data?.message || 'Failed to resend invitation',
        status: error.response?.status,
        data: error.response?.data
      }
    }
  }
};

export const sendInvite = async (inviteData) => {
  try {
    const response = await api.post(`TenantUserInvites/send-invitation`, inviteData, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;

  }
};
